import React, { useState } from 'react';
import { AlertTriangle, Trash2 } from 'lucide-react';
import api, { getApiErrorMessage } from '../../services/api';

export default function FactoryResetPanel() {
  const [open, setOpen] = useState(false);
  const [confirmation, setConfirmation] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const reset = async () => {
    if (confirmation !== 'APAGAR' || busy) return;
    setBusy(true); setError('');
    try {
      await api.post('/backup/sistema/reset-fabrica', { confirmacao: confirmation });
      for (const key of ['authUser', 'authToken', 'authUserData', 'authPermissions']) localStorage.removeItem(key);
      window.location.assign('/');
    } catch (err) {
      setError(getApiErrorMessage(err, 'Não foi possível redefinir o sistema.'));
      setBusy(false);
    }
  };
  return (
    <section className="factory-reset-panel rounded-2xl border p-6">
      <div className="flex items-center gap-3"><AlertTriangle size={24} /><h2 className="text-lg font-semibold">Reset de fábrica</h2></div>
      <p className="mt-3 text-sm leading-relaxed">Apaga os cadastros de todos os condomínios, usuários, dispositivos cadastrados, históricos, configurações e imagens locais. O sistema volta vazio, com um condomínio padrão. Apenas o seu login e senha de Super Administrador são mantidos para permitir o acesso.</p>
      <p className="mt-3 text-sm font-semibold">Esta ação é permanente. Baixe e guarde um backup antes de continuar. Os dados armazenados nos equipamentos e a conexão externa do WhatsApp não são apagados.</p>
      {!open ? <button type="button" onClick={() => setOpen(true)} className="factory-reset-button mt-5 inline-flex items-center gap-2 rounded-xl px-5 py-3 text-sm font-semibold"><Trash2 size={17} />Redefinir sistema</button> : (
        <div className="mt-5 border-t pt-5">
          <label className="block text-sm font-semibold" htmlFor="factory-reset-confirmation">Para confirmar a exclusão definitiva, digite APAGAR</label>
          <input id="factory-reset-confirmation" autoComplete="off" spellCheck={false} disabled={busy} value={confirmation} onChange={(e) => setConfirmation(e.target.value)} className="mt-2 w-full max-w-sm rounded-xl border bg-white px-4 py-3" />
          {error && <p role="alert" className="mt-3 text-sm">{error}</p>}
          {busy && <p role="status" className="mt-3 text-sm">Apagando os dados e redefinindo o sistema. Mantenha esta página aberta...</p>}
          <div className="mt-4 flex flex-wrap gap-3">
            <button type="button" disabled={busy || confirmation !== 'APAGAR'} onClick={reset} className="factory-reset-button inline-flex items-center gap-2 rounded-xl px-5 py-3 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-50"><Trash2 size={17} />{busy ? 'Redefinindo...' : 'Apagar tudo e redefinir'}</button>
            <button type="button" disabled={busy} onClick={() => { setOpen(false); setConfirmation(''); setError(''); }} className="rounded-xl border px-5 py-3 text-sm font-semibold">Cancelar</button>
          </div>
        </div>
      )}
    </section>
  );
}
